module.exports = __webpack_public_path__ + "media/images/home/logo-clutter-footer-ada520c615230dcdf7e3b6162f115441.png";